import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  align-items: center;
`;

export const Box = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;

  > div {
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 600;
  }
  &.sideA > div {
    background-color: var(--mode-bg-primary-weakest);
    color: var(--mode-text-primary-default);
  }
  &.sideB > div {
    background-color: var(--mode-bg-secondary-weakest);
    color: var(--mode-text-secondary-default);
  }
`;

export const Label = styled.div``;
